import React from 'react';
import { Award, Users, CheckCircle, Clock } from 'lucide-react';
import { mockData } from '../data/mock';

const iconMap = {
  Award,
  Users,
  CheckCircle,
  Clock
};

const Values = () => {
  return (
    <section id="valeurs" className="section-values">
      <div className="container">
        <div 
          className="section-header"
          data-aos="fade-up"
        >
          <h2 className="section-title">Pourquoi choisir Bouhdel ?</h2>
          <p className="section-subtitle">
            Des valeurs fortes et un engagement sans faille pour votre satisfaction
          </p>
        </div>

        <div className="values-grid">
          {mockData.values.map((value, index) => {
            const IconComponent = iconMap[value.icon];
            return (
              <div 
                key={value.id} 
                className="value-card"
                data-aos="zoom-in"
                data-aos-delay={index * 150}
              >
                <div className="value-icon-wrapper">
                  {IconComponent && <IconComponent size={40} className="value-icon" />}
                </div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            );
          })}
        </div>

        <div className="stats-grid" data-aos="fade-up" data-aos-delay="200">
          {mockData.stats.map((stat, index) => (
            <div 
              key={index} 
              className="stat-item"
              data-aos="fade-up"
              data-aos-delay={300 + index * 100}
            >
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
